import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeactiveGuard implements CanDeactivate<NavigationConfirm> {
  canDeactivate(
    component: NavigationConfirm,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return component?.canDeactivate() ?? true;
  }

}

export interface NavigationConfirm {
  canDeactivate(): Observable<boolean>;
}
